export const renderWithLinks = (str) => {
  if (!str) return null;
  const regex = /`([^`]+)`(?:\(([^)]*)\))?/g;
  const result = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(str)) !== null) {
    // Добавляем текст до ссылки
    if (match.index > lastIndex) {
      result.push(str.slice(lastIndex, match.index));
    }

    const url = match[1].trim();
    const text = match[2]?.trim() || url;

    result.push(<a href={url}>{text}</a>);

    lastIndex = match.index + match[0].length;
  }

  // Добавляем оставшийся текст
  if (lastIndex < str.length) {
    result.push(str.slice(lastIndex));
  }

  return <span>{result}</span>;
};
